import classes from "./AdTabs.module.scss";
import { tabs } from "./config/tabs";
import AdTab from "./AdTab";
import { memo } from "react";

const AdTabs = () => {
  return (
    <div className={classes.advertTabs}>
      <AdTab link={tabs.RGCams.link} label={tabs.RGCams.label} key={tabs.RGCams.label}/>
      <AdTab link={tabs.LiveSex.link} label={tabs.LiveSex.label} key={tabs.LiveSex.label}/>
      <AdTab link={tabs.SexGames.link} label={tabs.SexGames.label} key={tabs.SexGames.label}/>
    </div>
  );
};

const AdTabsMemo = memo(AdTabs);

export default AdTabsMemo;
